import Vue from 'vue';
import Vuex from 'vuex';
import {
	PAGE_TITLE,
	PROGRESS_START,
	PROGRESS_FINISH,
	PROGRESS_FAIL,
} from './mutation-types';
import auth from './modules/auth';
import maps from './modules/maps';
import transactionList from './modules/transaction/transaction';
import productList from './modules/product/product';
import dashboardList from './modules/dashboard/dashboard'
import reportList from './modules/report/report'
import registrasiList from './modules/registrasi/registrasi'
import inventoryList from './modules/inventory/inventory'
import profileList from './modules/setting/profile'
import edcList from './modules/setting/edc'
import commonList from './modules/common/common'
import cart from './modules/transaction/cart';
import receipt from './modules/receipt/receipt';
import serial from './modules/serial/serial';
import po from './modules/po/po';
import po_cart from './modules/po/cart';
import inventoryListDigital from './modules/inventory/inventory_digital';
import voucherList from './modules/voucher/voucher';
import tutorialList from './modules/tutorial/tutorial';
import followupList from './modules/followup/followup';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		pageTitle: "Stockist Mobile Counter",
		progressStatus: "",
	},
	mutations: {
		[PAGE_TITLE](state, title) {
			state.pageTitle = title;
		},

		[PROGRESS_START](state) {
			state.progressStatus = "start";
		},

		[PROGRESS_FINISH](state) {
			state.progressStatus = "finish";
		},

		[PROGRESS_FAIL](state) {
			state.progressStatus = "fail";
		},
	},
	actions: {
		setPageTitle({ commit }, title) {
			commit(PAGE_TITLE, title);
		},
	},
	modules: {
		auth,
		maps,
		transactionList,
		productList,
		dashboardList,
		reportList,
		registrasiList,
		inventoryList,
		commonList,
		cart,
		profileList,
		edcList,
		receipt,
		serial,
		po,
		po_cart,
		inventoryListDigital,
		voucherList,
		tutorialList,
		followupList
	},
});